import * as React from "react"
import { CacheProvider } from "@emotion/react"
import { CssBaseline, ThemeProvider } from "@mui/material"

import theme from "./src/theme"
import createEmotionCache from "./src/utils/createEmotionCache"

const clientSideEmotionCache = createEmotionCache()

export const wrapRootElement = ({ element }) => (
  <CacheProvider value={clientSideEmotionCache}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {element}
    </ThemeProvider>
  </CacheProvider>
)
